<div class="layout">
  <!-- Tool bar -->
  <div class="layout__toolbar">
    <mat-toolbar color="primary">

      <!-- Logo -->
      <div class="layout__logo">
        <span class="logoImg">
            <!-- <img src="./assets/login-logo.png" alt="InstrumentsUI"> -->
            <img src="./assets/instruments-platform.svg" alt="InstrumentsUI">
        </span>
        <h1 class="logoText" i18n="Instrument Platform label|Label text for Instrument platform@@appInstPlatInMainPage">
            Instruments Platform 
        </h1>
      </div>

      <!-- tool bar buttons - only shows when organization exists -->
      <ng-container *ngIf="organization$ | async as organization">
        <ng-container *ngFor="let n of navigationItems; index as i">
          <ng-container *ngIf="!n.hidden">
            <button 
              mat-flat-button 
              [ngClass]="{'layout__toolbar-button--selected': i === currentNavigationIndex}"
              class="layout__toolbar-button" 
              (click)="navClick(n, organization.organizationCode, i)"
            >
              <h2>{{ n.title }}</h2>
            </button>
          </ng-container>
        </ng-container> 

        <span class="spacer"></span>

        <!-- Organization card -->
        <div class="layout__organization-card">
          <app-text-with-logo 
            [logo]="'./assets/organization-logo.svg'" 
            [text]="organization.organizationName" 
            [size]="'small'"
          />
        </div>
      </ng-container>

      <!-- Locale Select -->
      <div class="layout__locale-select">
        <app-locale-select [showIcon]="true"></app-locale-select>
      </div>
      
      <!-- User info -->
      <div class="layout__user-info">
        <button mat-icon-button [matMenuTriggerFor]="userMenu">
          <img src="./assets/user.svg" alt="UserIcon">
        </button>
        
        <!-- User Menu -->
        <mat-menu class="user-menu" #userMenu="matMenu">
          <ng-template matMenuContent>
            <ng-container *ngIf="getFaqFile('GWS') !== undefined">
              <button mat-menu-item (click)="openFaqFile('GWS')" *featureFlag="'faqGWSVisibility'">
                <mat-icon>help_outline</mat-icon>
                <span i18n="FAQ label|Header label for FAQ navigation link@@appFAQGWSInMainPage">GWS Handbook</span>
              </button>
            </ng-container>
            <ng-container *ngIf="getFaqFile('GBA') !== undefined">
              <button mat-menu-item (click)="openFaqFile('GBA')" *featureFlag="'faqGBAVisibility'">
                <mat-icon>help_outline</mat-icon>
                <span i18n="FAQ label|Header label for FAQ navigation link@@appFAQGBAInMainPage">FAQ - Governing Body Assessment</span>
              </button>
            </ng-container>
            <button mat-menu-item (click)="openSampleReport('GWS')" *featureFlag="'sampleReport'">
              <mat-icon data-test-id="icon">assessment</mat-icon>
              <span i18n="Sample GWS Report label|Header label for Sample GWS Report navigation link@@appSampleGwsReportInMainPage">Sample Report - Global Workforce Survey</span>
            </button>
            <button mat-menu-item (click)="openSampleReport('GBA')" *featureFlag="'sampleReport'">
              <mat-icon data-test-id="icon">assessment</mat-icon>
              <span i18n="Sample GBA Report label|Header label for Sample GBA Report navigation link@@appSampleGbaReportInMainPage">Sample Report - Governing Body Assessment</span>
            </button>
            <button mat-menu-item (click)="logOut()">
              <mat-icon>exit_to_app</mat-icon>
              <span  i18n="Logout label|Header label for Logout navigation link@@appLogoutInMainPage">Logout</span>
            </button>
          </ng-template>
        </mat-menu>
      </div>
    </mat-toolbar>
  </div>
  <!-- Content -->
  <div class="layout__content">
    <router-outlet *ngIf="true"></router-outlet>
  </div>
  <!-- Footer -->
  <div class="layout__footer">
      <!-- <div>Terms of Service | Privacy Notice | Contact us</div> -->
      <div>
        <a  href="#" (click)="openTermsOfUse()"  i18n="Terms label|Footer label for Terms of Service navigation link@@appTermsInMainPage">Terms of Service</a>
        |
        <a href="#" (click)="openPrivacyPolicy()" i18n="Policy label|Footer label for Privacy Notice navigation link@@appPrivacyInMainPage">Privacy Notice</a>
        |
        <a [href]="'https://onboardqi.com/#/contact/' + baseLang"  i18n="Contact Us label|Footer label for Contact Us navigation link@@appContactUsInMainPage">Contact us</a>
      </div>
      <span class="spacer"></span>
      <div><span  i18n="Copyrights text|Footer text for copyrights text@@appCopyRightsInMainPage">© {{fullYear}} Health Standards Organization (HSO) and its licensors. All rights reserved.</span></div>
  </div>
</div>
